export const HEIC_HEIF_ACCEPT_LIST = 'image/heic, image/heif, .heic, .heif';

/**
 * HEIC/HEIF — often `image/heic` / `image/heif`, but some OS pickers use empty or octet-stream.
 */
export function imageNeedsConversion(file: Pick<File, 'name' | 'type'>): boolean {
  const mime = (file.type ?? '').split(';')[0].trim().toLowerCase();
  if (mime === 'image/heic' || mime === 'image/heif') {
    return true;
  }
  const lower = file.name.toLowerCase();
  return lower.endsWith('.heic') || lower.endsWith('.heif');
}

/**
 * Image uploads: standard `image/*` MIME or HEIC/HEIF (extension / MIME).
 */
export function isImageFile(file: Pick<File, 'name' | 'type'>): boolean {
  const type = file.type ?? '';
  return type.startsWith('image/') || imageNeedsConversion(file);
}
